<template>
    <page>
        <template slot="header">
            <div class="container-fluid">
                <div>
                    <div class="row">
                        <div class="col-12 col-sm-7">
                            <h3 class="m-0 text-dark font-weight-normal">
                                <router-link to="/" class="btn btn-dark mr-2">
                                    <i class="fas fa-angle-double-left"></i>
                                    {{ $t('Voltar') }}
                                </router-link>
                                <span class="text-muted">{{ $t('Nova OS') }}</span>
                            </h3>
                        </div>
                    </div>
                    <div class="row">
                        <NovaOsComponent />
                    </div>
                </div>
            </div>
        </template>
    </page>
</template>
<script>
import Page from '@/components/Page'
import NovaOsComponent from '@/components/NovaOsComponent'

export default {
  name: 'NovaOs',
  components: {
    Page,
    NovaOsComponent
  }
}
</script>
